var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "134px",
    height: "134px",
    viewBox: "0 0 134 134",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("text", {
    id: "text-cji9xoc245-1",
    fontFamily: "AppleColorEmoji, Apple Color Emoji",
    fontSize: 106,
    fontWeight: "normal",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 198,
    y: 106
  }, "\uD83E\uDD7A")), /*#__PURE__*/React.createElement("filter", {
    x: "-33.0%",
    y: "-18.0%",
    width: "167.0%",
    height: "150.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-cji9xoc245-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 10,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.75 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Updates-May-2022",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cancelation-3",
    transform: "translate(-653.000000, -137.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83E\\uDD7A",
    transform: "translate(469.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-cji9xoc245-2)",
    xlinkHref: "#text-cji9xoc245-1"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#text-cji9xoc245-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadEmoji);
export default __webpack_public_path__ + "static/media/sad-emoji.aef281e72bb64b559075611ee69ebc6f.svg";
export { ForwardRef as ReactComponent };